var _path, _path2, _path3, _path4, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTvOsCircled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.3552 50C65.9182 50 58.7148 58.1962 58.7148 71.2006C58.7148 84.2049 65.9123 92.3746 77.3552 92.3746C88.7981 92.3746 96.022 84.2078 96.022 71.2006C96.022 58.1962 88.7922 50 77.3552 50V50ZM77.3552 88.7597C68.3665 88.7597 62.701 81.9599 62.701 71.2035C62.701 60.4471 68.3606 53.6179 77.3552 53.6179C86.3498 53.6179 92.0418 60.4176 92.0388 71.2035C92.0388 81.9599 86.3469 88.7597 77.3552 88.7597V88.7597Z",
    fill: "#2D2F35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1445 91.694C23.7468 91.806 22.1529 91.8649 21.3545 91.8649C16.4049 91.8649 14.4104 89.7584 14.4104 84.4376V65.2552H10V62.1264H14.4104V54.7286H18.1668V62.1264H24.0031V65.2552H18.1668V84.2373C18.1668 87.3131 19.3629 88.5888 22.094 88.5888C22.4917 88.5888 23.9147 88.5298 24.1445 88.5063V91.694V91.694Z",
    fill: "#2D2F35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7549 91.7235H38.7393L27.7266 62.1264H31.7127L40.7073 87.7668H40.7898L49.8139 62.1264H53.7411L42.7549 91.7235Z",
    fill: "#2D2F35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.122 92.3746C106.528 92.3746 100.495 87.6224 100.067 80.5664H103.965C104.392 85.4924 109.033 88.8451 115.461 88.8451C121.89 88.8451 126.017 85.4865 126.017 80.8757C126.017 77.0339 123.369 74.7566 117.282 73.2187L112.191 71.9106C104.593 69.975 101.205 66.7607 101.205 61.3545C101.205 54.7256 107.182 50 115.261 50C123.339 50 129.119 54.7256 129.346 61.2396H125.449C125.077 56.6023 120.979 53.5295 115.146 53.5295C109.312 53.5295 105.241 56.6878 105.241 61.2131C105.241 64.7426 107.801 66.8196 113.835 68.3575L118.275 69.4977C126.53 71.5747 130 74.7359 130 80.4544C130.003 87.6519 124.196 92.3775 115.119 92.3775L115.122 92.3746Z",
    fill: "#2D2F35"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 69.5,
    stroke: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvOsCircled);
export default __webpack_public_path__ + "static/media/tv-os-circled.8192444c48f52fff8ab0d4eb0a3d80d6.svg";
export { ForwardRef as ReactComponent };